import { DesignSystem } from '@/src/design-system'
import { YStack } from 'tamagui'
import { SectionSkeleton } from '../Section'
import * as Mortgage from '@/src/experiences/mortgage'

export function MesaSectionSkeleton() {
  return (
    <SectionSkeleton>
      <YStack gap="$4">
        <Mortgage.Components.StateCallPromoCardSkeleton />
        <Mortgage.Components.BenefitsSkeleton />
        <DesignSystem.Skeleton.Skeleton
          style={{ width: '100%', height: 400, overflow: 'hidden', borderRadius: 16 }}
        />
      </YStack>
    </SectionSkeleton>
  )
}
